export default {
    root:{
        zIndex: '2',
    },
    button:{
		width: "100%",
		padding: "1rem",
		marginTop: "1rem",
		fontSize: "1em",
		textTransform: "capitalize",
	},
	clearBtn:{
		color: "white",
		backgroundColor: "#b71c1c"
	},
	colorNameForm:{
		width: "100%",
		height: "70px"
	
	},
	colorBoxSample:{
		width: "100%",
		height: "100px",
		"& span":{
			display:"flex",
			justifyContent: "center",
			alignItems:"center",
			color: "white"
		}
	}
}